import {FunctionComponent, MouseEventHandler} from 'react';
import {DfbCloseSymbol} from '../symbol/Symbol';

export type ModalProps = {
    close: MouseEventHandler<HTMLButtonElement>,
    visible: boolean
    fullSize?: boolean
}

const Modal: FunctionComponent<ModalProps> = (props) => {
    return (
        <div
            className={`dfb-Modal${props.fullSize ? ' dfb-Modal--fullsize' : ''}${props.visible ? ' is-active is-visible' : ''} dfb-Modal--focusTrap`}
            role="dialog" tabIndex={-1}>
            <div className="dfb-Modal-surface">
                <div className="dfb-Modal-container">
                    <div className="dfb-Modal-content" role="document" tabIndex={-1}>
                        <div className="dfb-Modal-contentContainer">
                            <button type="button" className="dfb-Modal-dismissButton" onClick={props.close}>
                                <DfbCloseSymbol/>
                            </button>
                            {
                                props.visible &&
                                <>
                                    {props.children}
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
